<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Menu Portal</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/portal/menu">Menu Portal</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Menu Portal</h4>
                  <!-- <p class="card-title-desc mb-0">Memuat nama atau tolok indikator, satuan, dan entitas selain data. Anda juga dapat untuk menampilkan atau tidak pada halaman muka.</p> -->
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <div class="table-responsive">
                <table class="table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">No</th>
                      <th>Menu Portal</th>
                      <th>Url / Path</th>
                      <th>Status</th>
                      <th>Perubahan Terakhir</th>
                      <th class="text-center">Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in menu" :key="index">
                      <td scope="row" class="text-center">{{ index + 1 }}</td>
                      <td scope="row" v-text="row.urai"></td>
                      <td scope="row">
                        <a class="fst-italic" :href="row.url" target="_blank" v-text="row.url"></a>
                      </td>
                      <td scope="row">
                        {{ row.is_published == 'Y' ? 'Publikasi': 'Tidak Ditampilkan' }}
                      </td>
                      <td scope="row">{{ (new Date(row.updated_at)).toLocaleString() }}</td>
                      <td scope="row" class="text-center">
                        <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> | 
                        <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                      </td>
                    </tr>
                    <tr v-if="menu.length == 0">
                      <td scope="row" colspan="6" class="text-center">
                        <i>Tidak ditemukan data!</i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah': 'Tambah') + ' Menu Portal'" backdrop="static">
    <template #default>
      <form @submit.prevent="action">
        <div class="mb-3">
          <label for="after" class="form-label">Tampil Setelah</label>
          <input :value="form.parent || '-'" type="text" class="form-control" readonly id="after" />
        </div>
        <div class="mb-3">
          <label for="urai" class="form-label">Urai Menu Portal</label>
          <input v-model="form.urai" type="text" class="form-control" id="urai" />
        </div>
        <div class="mb-3">
          <label for="url" class="form-label">Link</label>
          <input v-model="form.url" type="url" class="form-control" id="url" />
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="is-publish" v-model="form.is_published">
          <label class="form-check-label" for="is-publish">
            Tampilkan di halaman utama
          </label>
        </div>
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" role="switch" id="is-open-newtab" v-model="form.open_newtab">
          <label class="form-check-label" for="is-open-newtab">
            Buka di Tab Baru
          </label>
        </div>
      </form>
    </template>
    <template #footer>
      <button type="button" class="btn btn-primary" @click="action">Simpan</button>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  layout: Layout,
  components: { Modal },
  props: {
    menu: Array
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        is_published: false,
        open_newtab: false,
        parent: '',
        parent_id: 0,
        url: '',
        urai: ''
      },
    }
  },
  methods: {
    edit({ id, urai, url, is_published, open_newtab, parent, parent_id }) {
      this.form.id = id;
      this.form.urai = urai;
      this.form.url = url;
      this.form.is_published = is_published == 'Y';
      this.form.open_newtab = open_newtab;
      this.form.parent = parent;
      this.form.parent_id = parent_id;
      this.form.show = true;
    },
    action() {
      if(this.form.id) {
        this.$inertia.put('/admin/portal/menu/' + this.form.id, this.form);
      } else {
        this.$inertia.post('/admin/portal/menu', this.form);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.urai = '';
      this.form.url = '';
      this.form.is_published = false;
      this.form.parent = '';
      this.form.parent_id = 0;
      this.form.open_newtab = false;
    },
    remove(row) {
      if(confirm('Hapus Data?'))
      this.$inertia.delete('/admin/portal/menu/' + row.id);
    }
  },
}
</script>
